// extracted by mini-css-extract-plugin
module.exports = {"PollAttemptsPage__title":"PollAttemptsPage_PollAttemptsPage__title__2rqbQ","PollAttemptsRow":"PollAttemptsPage_PollAttemptsRow__waDpl"};